export default (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 505.299 505.299">
    <g>
      <path
        d="m239.496 384.74v120.559c49.481-3.235 95.86-22.446 133.137-55.147l-85.248-85.247c-14.076 10.571-30.46 17.358-47.889 19.835z"
        fill={"#4C709A"}
      />
      <path
        d="m212.93 176.436 11.53-1.27 17.378-119.364h-17.342c-55.071 0-107.114 19.664-148.136 55.65l85.251 85.252c14.929-11.232 32.412-18.185 51.319-20.268z"
        fill={"#9B4244"}
      />
      <path
        d="m328.772 293.157c-2.186 18.604-9.102 35.809-20.179 50.529l85.252 85.252c35.987-41.022 55.651-93.064 55.651-148.136v-17.341l-120.725 17.57v12.126z"
        fill={"#664980"}
      />
      <path
        d="m140.395 217.913-85.247-85.247c-32.702 37.277-51.913 83.655-55.148 133.137h120.559c2.477-17.429 9.263-33.814 19.836-47.89z"
        fill={"#A66A40"}
      />
      <path
        d="m76.36 450.151c37.276 32.701 83.654 51.912 133.136 55.147v-120.558c-17.429-2.478-33.812-9.265-47.889-19.836z"
        fill={"#569556"}
      />
      <path
        d="m120.559 295.803h-120.559c3.235 49.481 22.446 95.859 55.147 133.136l85.247-85.247c-10.572-14.077-17.358-30.461-19.835-47.889z"
        fill={"#B7AA5E"}
      />
      <path
        d="m385.809 14.537h59.999v149.906h-59.999z"
        transform="matrix(.707 -.707 .707 .707 58.507 320.23)"
        fill={"#999da0"}
      />
      <path d="m496.513 8.787-.001-.001c-11.715-11.715-30.71-11.715-42.426 0l-17.064 17.064 42.427 42.427 17.064-17.065c11.715-11.715 11.715-30.71 0-42.425z" />
      <path d="m198.89 306.409h42.426l153.206-153.206-42.426-42.427-153.206 153.206z" />
    </g>
  </svg>
);
